import type { HttpErrorResponse } from '@angular/common/http';

import type { CorrelationId, PickActions } from '@recruitee/ngrx';
import { createEntityCollectionStore, getEntityCollectionActions } from '@recruitee/ngrx';
import type { PipelineTemplateItem } from '@recruitee/pipeline-templates-types';
import type { PlacementMovement } from '@recruitee/stages-types';

export interface SaveAsTemplatePayload {
  title: string;
  category: string;
  offerId: number;
}

export interface AssignToOfferPayload {
  offerId: number;
  pipelineTemplateId: number;
  placementsMovements?: PlacementMovement[];
}

const idSelector = ({ id }: { id: number }) => id;
const { actions, reducer } = createEntityCollectionStore<PipelineTemplateItem>()(
  'PipelineTemplateOfferItem',
  {
    idSelector,
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        fetchOne: (state, payload: { offerId: number; templateId: number }) =>
          defaultActions.fetchOne(state, { id: payload.templateId }),

        saveAsTemplate: (
          state,
          payload: { data: SaveAsTemplatePayload } & Required<CorrelationId>,
        ) => defaultActions.createOnePessimistic(state, payload),
        saveAsTemplateSuccess: (
          state,
          payload: { data: PipelineTemplateItem } & Required<CorrelationId>,
        ) => defaultActions.createOnePessimisticSuccess(state, payload),
        saveAsTemplateFailed: (
          state,
          payload: { error: HttpErrorResponse } & Required<CorrelationId>,
        ) => defaultActions.createOnePessimisticFailed(state, payload),

        assignTemplateToOffer: (state, payload: AssignToOfferPayload) => state,
        assignTemplateToOfferSuccess: (state, payload: { data: PipelineTemplateItem }) => state,
        assignTemplateToOfferFailed: (state, payload: { error: HttpErrorResponse }) => state,
      };
    },
  },
);

const PipelineTemplateOfferItemActions: PickActions<
  typeof actions,
  'fetchOne' | 'saveAsTemplate' | 'assignTemplateToOffer'
> = actions;

export { PipelineTemplateOfferItemActions, reducer as PipelineTemplateOfferItemReducer };
